import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-917a87695cc943acae31ac6086276c76/input/1603358965782/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { throttle } from 'lodash-es';
import walletReq from "../../services/walletService";
import Slide from "../../components/SlideList/slide/Slide";
export default {
  name: 'Wallet',
  data: function data() {
    return {
      items: [],
      reach_first: true,
      reach_last: true
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this = this;

      var items;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return walletReq(this.vip.isVip());

            case 2:
              items = _context.sent;

              if (this.vip.useScore) {
                items.forEach(function (item) {
                  if (item.text === '成长值') {
                    item.text = 'V力值';
                  }
                });
              }

              this.items = items;
              this.$nextTick(function () {
                var $el = $(_this.$el);
                _this.slide = _this.createSlide($el, {
                  offset: 0
                });
                var func = throttle(function () {
                  setTimeout(function () {
                    _this.slide.refresh();
                  }, 0);
                }, 50);
                $(window).on('resize', func);

                _this.$on('hook:beforeDestroy', function () {
                  $(window).off('resize', func);
                });
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    prev: function prev() {
      this.slide.prev();
    },
    next: function next() {
      this.slide.next();
    },
    createSlide: function createSlide($el, options) {
      var _this2 = this;

      var slide = new Slide($.extend({
        el: $el.find('[data-role="slide-wrapper"]'),
        inner: '[data-role="slide-inner"]'
      }, options));
      slide.on('onview', function (items) {
        _this2.reach_first = false;
        _this2.reach_last = false;
      });
      slide.on('reach_first', function () {
        _this2.reach_first = true;
      });
      slide.on('reach_last', function () {
        _this2.reach_last = true;
      });
      slide.first();
      return slide;
    }
  }
};